// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"238":"b6023fa3","595":"09ee5aca","617":"49a03919","695":"4f249552","739":"e5282a1b","891":"cbe77bbf"}[chunkId] + ".js";
};